// START IMPORTS
import { useTheme } from '@ltvco/refresh-lib/theme';
import { NavLinkDataV2 } from '@ltvco/refresh-lib/v2';
import {
  Security,
  Message,
  List,
  Policy,
  Radar,
  PhoneAndroid,
  HistoryOutlined,
} from '@mui/icons-material';
// END IMPORTS

// START INTERFACES_AND_TYPES
type DataCounts = {
  commentsLength: number;
};

type DeviceDataCounts = {
  historyLength: number;
};
// END INTERFACES_AND_TYPES

// START HELPER_FUNCTIONS
export const getFraudPhoneNavLinkDataV2 = (DataCounts: DataCounts) => {
  const theme = useTheme();

  let threatDetection: NavLinkDataV2[] = [];

  threatDetection = [
    {
      href: '#threat-detection-section',
      sectionId: '#threat-detection-section',
      labelText: 'Threat Detection',
      hideReportItemsCount: true,
      icons: [<Radar sx={{ color: theme.palette.primary.main }} />],
    },
  ];

  return [
    {
      href: '#fraud-phone-overview-section',
      sectionId: '#fraud-phone-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'phone-fraud-phone-overview-section',
    },
    ...threatDetection,

    {
      href: '#comments-section',
      sectionId: '#comments-section',
      labelText: 'Comments',
      icons: [<Message sx={{ color: theme.palette.primary.main }} />],
      reportItemsCount: DataCounts.commentsLength,
    },
  ];
};

export const getFraudEmailNavLinkDataV2 = () => {
  const theme = useTheme();
  return [
    {
      href: '#fraud-email-overview-section',
      sectionId: '#fraud-email-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'email-fraud-overview-section',
    },
    {
      href: '#additional-details-section',
      sectionId: '#additional-details-section',
      labelText: 'Additional Details',
      icons: [<List sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
  ];
};

export const getFraudIpNavLinkDataV2 = () => {
  const theme = useTheme();
  return [
    {
      href: '#fraud-ip-overview-section',
      sectionId: '#fraud-ip-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'ip-fraud-overview-section',
    },
    {
      href: '#additional-details-section',
      sectionId: '#additional-details-section',
      labelText: 'Additional Details',
      icons: [<List sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
  ];
};

export const getFraudDeviceNavLinkDataV2 = (
  dataCounts: DeviceDataCounts = { historyLength: 0 }
) => {
  const theme = useTheme();
  return [
    {
      href: '#device-fraud-overview-section',
      sectionId: '#device-fraud-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'device-fraud-overview-section',
    },
    {
      href: '#device-fraud-device-section',
      sectionId: '#device-fraud-device-section',
      labelText: 'Device',
      icons: [<PhoneAndroid sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
    {
      href: '#device-fraud-details-section',
      sectionId: '#device-fraud-details-section',
      labelText: 'Registry Details',
      icons: [<List sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
    {
      href: '#device-fraud-history-section',
      sectionId: '#device-fraud-history-section',
      labelText: 'IMEI History',
      icons: [<HistoryOutlined sx={{ color: theme.palette.primary.main }} />],
      reportItemsCount: dataCounts.historyLength,
    },
  ];
};

export const getFraudUrlNavLinkDataV2 = () => {
  const theme = useTheme();
  return [
    {
      href: '#fraud-url-overview-section',
      sectionId: '#fraud-url-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'url-fraud-overview-section',
    },
    {
      href: '#risk-details-section',
      sectionId: '#risk-details-section',
      labelText: 'Risk Details',
      icons: [<Policy sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
    {
      href: '#additional-details-section',
      sectionId: '#additional-details-section',
      labelText: 'Additional Details',
      icons: [<List sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
  ];
};
// END HELPER_FUNCTIONS
